
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { FIREBASE_API_KEY, FIREBASE_APP_ID, FIREBASE_AUTH_DOMAIN, FIREBASE_MEASUREMENT_ID, FIREBASE_MESSAGING_SENDER_ID, FIREBASE_PROJECT_ID, FIREBASE_STORAGE_BUCKET } from "../Constant";

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
  measurementId:FIREBASE_MEASUREMENT_ID
};
const firebaseApp = initializeApp(firebaseConfig);
export const getFirebaseMessaging = async () => {
  const supported = await isSupported();
  if (!supported) {
    console.warn("🚫 Push messaging not supported in this browser.");
    return null;
  }
  return getMessaging(firebaseApp);
};

// export { messaging};


